// extracted by mini-css-extract-plugin
export default {"Collaborator":"Collaborator_Collaborator__5JS6h"};